const topics = [
  {
    title: '刃牙第一部：地下斗技场篇',
    desc: '范马刃牙的起点，地下斗技场中与世界各国格斗家展开殊死对决，奠定热血格斗经典地位。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Underground%20fighting%20arena%20scene%20with%20dramatic%20manga%20art%20style%2C%20dark%20atmospheric%20lighting%2C%20two%20fighters%20in%20silhouette%20facing%20off%20in%20a%20circular%20arena%2C%20crowd%20in%20shadows%2C%20warm%20crimson%20and%20amber%20spotlights%2C%20brushstroke%20ink%20effects%2C%20intense%20composition%2C%20no%20text&width=800&height=500&seq=carousel-baki-1&orientation=landscape',
  },
  {
    title: '刃牙II：最凶死刑犯篇',
    desc: '五名史上最凶恶死刑犯越狱挑战，柳龙光、铎尔、西科尔斯基——每一个名字都代表极限战斗。',
    tag: '人气最高',
    img: 'https://readdy.ai/api/search-image?query=Prison%20break%20scene%20in%20manga%20art%20style%2C%20shadowy%20figures%20emerging%20from%20darkness%2C%20dramatic%20ink%20wash%20effects%2C%20ominous%20atmosphere%20with%20crimson%20undertones%2C%20japanese%20brushstroke%20style%2C%20intense%20and%20moody%20composition%2C%20no%20visible%20characters%2C%20atmospheric%20abstract&width=800&height=500&seq=carousel-baki-2&orientation=landscape',
  },
  {
    title: '范马刃牙：地上最强父子决战',
    desc: '刃牙与父亲范马勇次郎的终极对决，史上最强父子之战，将格斗漫画推向新的巅峰。',
    tag: '巅峰之战',
    img: 'https://readdy.ai/api/search-image?query=Epic%20confrontation%20scene%20in%20manga%20style%2C%20two%20powerful%20silhouettes%20facing%20each%20other%20with%20intense%20energy%20lines%2C%20dramatic%20crimson%20and%20gold%20lighting%2C%20brushstroke%20ink%20effects%2C%20stormy%20sky%20background%2C%20powerful%20composition%2C%20no%20text%20or%20characters&width=800&height=500&seq=carousel-baki-3&orientation=landscape',
  },
  {
    title: '刃牙道：宫本武藏复活',
    desc: '传奇剑豪宫本武藏在现代复活，与当代格斗家们的跨时代对决，传统武术与现代格斗的激烈碰撞。',
    tag: '剑豪降临',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20japanese%20samurai%20aesthetic%20with%20modern%20manga%20fusion%20style%2C%20traditional%20katana%20sword%20in%20dramatic%20lighting%2C%20ink%20wash%20and%20brushstroke%20textures%2C%20warm%20amber%20and%20deep%20red%20accents%2C%20atmospheric%20and%20epic%20composition%2C%20no%20text&width=800&height=500&seq=carousel-baki-4&orientation=landscape',
  },
  {
    title: '刃牙道II：相扑道篇',
    desc: '相扑力士与格斗家的正面碰撞，日本国技以全新姿态进入刃牙世界，力量与技巧的巅峰对决。',
    tag: '最新连载',
    img: 'https://readdy.ai/api/search-image?query=Sumo%20wrestling%20arena%20in%20dramatic%20manga%20art%20style%2C%20traditional%20dohyo%20ring%20with%20atmospheric%20lighting%2C%20ink%20brush%20textures%2C%20warm%20golden%20and%20crimson%20accents%2C%20powerful%20composition%20with%20intense%20energy%2C%20japanese%20aesthetic%2C%20no%20text&width=800&height=500&seq=carousel-baki-5&orientation=landscape',
  },
  {
    title: '外传系列：花山薰与镐昴升',
    desc: '刃牙世界中的人气角色外传故事，深入探索每一位战士背后的传奇，补充主线未尽的精彩内容。',
    tag: '外传合集',
    img: 'https://readdy.ai/api/search-image?query=Side%20story%20manga%20art%20style%2C%20strong%20warrior%20silhouette%20standing%20against%20dramatic%20sky%2C%20brushstroke%20ink%20effects%2C%20warm%20amber%20and%20crimson%20lighting%2C%20atmospheric%20and%20heroic%20composition%2C%20japanese%20sumi-e%20aesthetic%20blend%2C%20no%20text&width=800&height=500&seq=carousel-baki-6&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          刃牙漫画全系列核心篇章一览，从地下斗技场到相扑道，热血永不熄灭
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {topics.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer transition-all hover:border-primary-200/60"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[11px] font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}